import { useWizard } from "../../Contexts/WizardContext";
import ProgressBar from "../../Components/ProgressBar"
import { useEffect, useRef } from "react"
import AddressInputTCM from "../../Components/WizzardStepsTCM/AddressInputTCM";
import PropertyTypeTCM from "../../Components/WizzardStepsTCM/PropertyTypeTCM";
import ContactInfoTCM from "../../Components/WizzardStepsTCM/ContactInfoTCM";
import PackageSelectionTCM from "../../Components/WizzardStepsTCM/PackageSelectionTCM";
import ThankYouCommTCM from "../../Components/WizzardStepsTCM/ThankYouCommTCM";

const wizardSteps = [
    { id: 1, component: AddressInputTCM },
    { id: 2, component: PropertyTypeTCM },
    { id: 3, component: ContactInfoTCM },
    { id: 4, component: PackageSelectionTCM },
    { id: 5, component: ThankYouCommTCM },
  ];

  const progressSteps = [
    { id: 1, label: 'Service Location' },
    { id: 2, label: 'Property Type' },
    { id: 3, label: 'Contact Info' },
    { id: 4, label: 'Choose Package' },
  ];

export default function SchedulerTCM() {
    const {currentStep, formData, resetAll} = useWizard()

    if (currentStep == 1) {
        resetAll()
    }

    const topRef = useRef(null);

    useEffect(() => {
      topRef.current?.scrollIntoView({ top: 0, behavior: 'smooth' });
    }, [currentStep]);

    const CurrentStepComponent = wizardSteps[currentStep - 1].component;
    
    return (
        <main ref={topRef} className="flex-1 flex flex-col justify-center py-8 px-4">
            <div className="max-w-4xl w-full mx-auto">
                <div className="bg-white rounded-2xl shadow-xl overflow-y-auto">
                    <ProgressBar
                        currentStep={currentStep}
                        totalSteps={progressSteps.length}
                        steps={progressSteps}
                    />
                    <div className="p-6 sm:p-8">
                        <CurrentStepComponent />
                    </div>
                </div>
            </div>
        </main>
    )
}